import translations from './translations'

translations.add('es', {
    iAgreeWith: 'Acepto',
    termsAndConditions: 'los términos y condiciones',
    pay: 'PAGAR'
})
